<template>
  <div>
    <div class="container my-5 px-3 px-lg-5">
      <article class="CardConfirmarPedido w-100" v-if="pedido">
        <div id="accordion" v-if="pedido.status === 'AGUARDANDO_CHECKOUT'">
          <div class="card">
            <div class="card-header" @click="goToStep('pedido')">
              <h5 class="mb-0">
                Pedido
              </h5>
            </div>
            <div :class="steps[0] ? 'show collapse' : 'collapse'">
              <div class="card-body">
                <StepConfirmacaoPedido
                  @goToStep="goToStep"
                  @obterCep="obterCep"
                  :objPedido="objPedido"
                ></StepConfirmacaoPedido>
              </div>
            </div>
          </div>

          <div
            class="card"
            v-if="
              objPedido.pedidoDTO && objPedido.pedidoDTO.possuiProdutoFisico
            "
          >
            <div class="card-header" @click="cep ? goToStep('endereco') : null">
              <h5 class="mb-0">
                Endereço
              </h5>
            </div>
            <div :class="steps[1] ? 'show collapse' : 'collapse'">
              <div class="card-body">
                <StepEndereco
                  v-if="steps[1]"
                  :cep="cep"
                  :idPedido="objPedido.pedidoDTO.id"
                  :objEndereco="enderecoEntrega"
                  :objEnderecoCobranca="enderecoCobranca"
                  :objEnderecoIgual="enderecoIgual"
                  @goToStep="goToStep"
                  @handleEndereco="handleEndereco"
                ></StepEndereco>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                Pagamento
              </h5>
            </div>
            <div :class="steps[2] ? 'show collapse' : 'collapse'">
              <div class="card-body">
                <StepPagamento
                  v-if="steps[2]"
                  @goToStep="goToStep"
                  @dadosPagamento="dadosPagamento"
                  :objPedido="objPedido.pedidoDTO"
                >
                  ""
                </StepPagamento>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                Confirmação de Pagamento
              </h5>
            </div>
            <div :class="steps[3] ? 'show collapse' : 'collapse'">
              <div class="card-body">
                <StepConfirmacaoPagamento
                  v-if="steps[3] && confirmacaoPagamento"
                  @goToStep="goToStep"
                  :confirmacaoPagamento="confirmacaoPagamento"
                  :objPedido="objPedido"
                >
                  ""
                </StepConfirmacaoPagamento>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card"
          v-if="pedido && pedido.status !== 'AGUARDANDO_CHECKOUT'"
        >
          <div class="card-header">
            <h5 class="mb-0">Pedido {{ pedido.status }}</h5>
          </div>
        </div>
      </article>
    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import { enderecoNoWrap } from '../shared/helpers/helpers'
import { APIService } from '../APIService'
const apiService = new APIService()

import StepConfirmacaoPedido from '../components/carrinho/StepConfirmarPedido'
import StepEndereco from '../components/carrinho/StepEndereco'
import StepPagamento from '../components/carrinho/StepPagamento'
import StepConfirmacaoPagamento from '../components/carrinho/StepConfirmacaoPagamento'

export default {
  name: 'ConfirmarPedido',
  components: {
    StepConfirmacaoPedido,
    StepEndereco,
    StepPagamento,
    StepConfirmacaoPagamento,
    Loading,
  },

  data() {
    return {
      steps: [true, false, false],
      cep: '',
      objPedido: { pedidoDTO: null },
      loading: true,
      pedido: null,
      quantidadeParcelas: 1,
      quantidadeMaximaParcelasConfig: null,
      enderecoForm: false,
      loadingCep: false,
      cepNaoLocalizado: false,
      enderecoEntrega: null,
      enderecoCobranca: null,
      enderecoIgual: false,
      confirmacaoPagamento: null,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    let pedidoId = null

    const obj = {
      redeLoja: {
        codigoLoja:
          this.$store.state.pedido.itens.length === 0
            ? null
            : this.$store.state.pedido.itens[0].produto.redeLoja.codigoLoja,
      },
      itens: this.$store.state.pedido.itens,
    }

    if (this.$route.params.pedidoId) {
      pedidoId = this.$route.params.pedidoId
    } else if (this.$store.state.pedido.id) {
      pedidoId = this.$store.state.pedido.id
    }

    this.loading = true

    if (pedidoId === null) {
      apiService
        .getPedidoPendente()
        .then((response) => {
          this.pedido = response
          this.objPedido.pedidoDTO = response

          if (!this.pedido) {
            apiService
              .cadastrarPedido(obj)
              .then((response) => {
                this.pedido = response
                this.objPedido.pedidoDTO = response
                this.setPedidoToLocalStorage(response)
              })
              .catch(() => (this.loading = false))
          } else {
            apiService
              .getPedidoPendente()
              .then((response) => {
                this.pedido = response
                this.objPedido.pedidoDTO = response
                this.setPedidoToLocalStorage(response)
              })
              .catch(() => (this.loading = false))
          }

          this.atualizarItensCarrinho(this.$store.state.pedido)
        })
        .catch(() => (this.loading = false))
    } else {
      this.atualizarItensCarrinho(this.$store.state.pedido)
    }
  },
  methods: {
    obterCep(cep) {
      this.cep = cep
    },
    goToStep(step) {
      const objStep = {
        pedido: [true, false, false, false],
        endereco: [false, true, false, false],
        pagamento: [false, false, true, false],
        confirmacaoPagamento: [false, false, false, true],
      }
      this.steps = objStep[step]
    },
    handleEndereco(obj) {
      this.enderecoEntrega = obj.enderecoEntrega
      this.enderecoCobranca = obj.enderecoCobranca
      this.enderecoIgual = obj.enderecoIgual
    },
    getDetalhes(id) {
      if (id > 0) {
        apiService.getPedidoID(id).then((response) => {
          this.objPedido.pedidoDTO = response
        })
      }
    },
    dadosPagamento(obj) {
      this.confirmacaoPagamento = obj
    },
    realizarCheckout() {
      this.loading = true
      const objCheckout = this.$store.state.dadosPessoais
      objCheckout.pedido = {
        codigoReferencia: this.pedido.codigoReferencia,
        quantidadeParcelas: this.quantidadeParcelas,
      }
      objCheckout.cliente.dataNascimento = new Date(
        `${objCheckout.cliente.dataNascimento.split('/')[1]}/${
          objCheckout.cliente.dataNascimento.split('/')[0]
        }/${objCheckout.cliente.dataNascimento.split('/')[2]}`,
      )
      objCheckout.cliente.cpf = objCheckout.cliente.cpf.replace(/\.|-/g, '')
      objCheckout.cliente.endereco.pais = 'BR'
      apiService
        .checkout(objCheckout)
        .then((response) => {
          this.$store.state.pedido.codigoPagamento = response.codigoPagamento
          this.$store.state.pedido.codigoCartao = response.codigoCartao
          this.$store.state.pedido.url = response.url
          this.goToStep('pagamento')
          this.loading = false
        })
        .catch(() => (this.loading = false))
    },
    adicionar(evt, produto) {
      const objDetalhes = {
        produto,
        quantidade: 1,
      }
      const action = evt ? 'pedidoAdicionarProduto' : 'pedidoRemoverProduto'
      this.$store.dispatch(action, objDetalhes)
    },
    endereco(end) {
      return enderecoNoWrap(end)
    },
    parcelasConfig() {
      this.parcelas = []
      let nParcelas = 1
      this.quantidadeMaximaParcelasConfig = this.quantidadeMaximaParcelasConfig.sort(
        (a, b) => b.valorPagamento - a.valorPagamento,
      )
      this.quantidadeMaximaParcelasConfig.forEach((e) => {
        if (this.pedido.valorTotal > e.valorPagamento) {
          while (nParcelas <= e.quantidadeMaximaParcelas) {
            this.parcelas.push({
              nParcelas: nParcelas,
              valorParcelas: +(this.pedido.valorTotal / nParcelas).toFixed(2),
            })
            nParcelas++
          }
        }
      })
    },
    setPedidoToLocalStorage(pedido) {
      this.$store.state.pedido.itens = []
      this.$store.state.pedido.valorTotal = 0
      this.$store.state.pedido.valorFrete = 0
      this.$store.state.pedido.valorCompra = 0
      this.$store.state.pedido.valorDesconto = 0
      this.$store.state.pedido.id = null

      if (pedido.status === 'AGUARDANDO_CHECKOUT') {
        this.$store.state.pedido.itens = pedido.itens
        this.$store.state.pedido.valorTotal = pedido.valorTotal
        this.$store.state.pedido.valorFrete = pedido.valorFrete
        this.$store.state.pedido.valorCompra = pedido.valorCompra
        this.$store.state.pedido.valorDesconto = pedido.valorDesconto
        this.$store.state.pedido.id = pedido.id
      }

      setTimeout(() => {
        localStorage.setItem(
          'carrinho',
          JSON.stringify(this.$store.state.pedido),
        )
      }, 500)
    },
    atualizarItensCarrinho(pedido) {
      this.loading = true
      apiService
        .atualizarItensCarrinho(pedido)
        .then(() => {
          apiService
            .getPedidoPendente()
            .then((response) => {
              this.pedido = response
              this.objPedido.pedidoDTO = response
              localStorage.setItem('carrinho', JSON.stringify(this.pedido))
            })
            .finally(() => (this.loading = false))
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false))
    },
  },
}
</script>
<style scoped lang="scss">
.btn-quantidade {
  width: 30px;
  height: 30px;
  border-radius: 50px;
  padding: 0.2em 0.35em;
}
.card {
  border-radius: 0 0 0.25rem 0.25rem;
}
</style>
